import React from 'react';
import { Note, NOTE_FLAGS } from '../../models/Note';
import { Badge } from '../primitives';

interface TasksBadgeProps {
  note: Note;
  hasLinkedTasks?: boolean;
  showTaskFlag?: boolean;
  className?: string;
}

const TasksBadge: React.FC<TasksBadgeProps> = ({ note, hasLinkedTasks = false, showTaskFlag = true, className = '' }) => {
  if (!hasLinkedTasks && (!showTaskFlag || !NOTE_FLAGS.hasFlag(note, NOTE_FLAGS.TASKS))) {
    return null;
  }

  return (
    <Badge variant="warning" className={className}>
      TASK
    </Badge>
  );
};

export default TasksBadge;
